import {
    InputAdornment,
    Paper,
    TableBody,
    TableCell,
    TableRow,
    Toolbar,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

import {
    AddLocationAltOutlined, DeleteForeverOutlined, LocationCityOutlined, Search,
} from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/Edit';
import RefreshIcon from '@mui/icons-material/Refresh';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Controls } from '../../components/controls/Controls';
import PageHeader from '../../components/PageHeader';
import Popup from '../../components/Popup';
import useTable from '../../components/useTable';
import ClientesForm from './UbicacionForm';
import { setIndex } from '../../redux/ducks/sideMenuIndex';
import ConfirmDialog from '../../components/ConfirmDialog';
import http from '../../http-common';
import { filterOnAnyField } from '../../utils';

const useStyles = makeStyles((theme) => ({
    pageContent: {
        margin: theme.spacing(5),
        padding: theme.spacing(3),
    },
    searchInput: {
        width: '75%',
    },
    newButton: {},
    refreshButton: {},
}));

const headCells = [
    { id: 'nombre', label: 'Nombre' },
    { id: 'telefono', label: 'Telefono' },
    { id: 'contacto', label: 'Contacto' },
    { id: 'direccion', label: 'Direccion' },
    { id: 'url', label: 'Url' },
    { id: 'actions', label: 'Acciones', disableSorting: true },

];

export default function Ubicaciones() {
    // eslint-disable-next-line
    const dispatch = useDispatch();

    const [openPopup, setOpenPopup] = useState(false);
    const classes = useStyles();
    const [filterFn, setFilterFn] = useState({
        fn: (items) => items,
    });
    const [recordForEdit, setRecordForEdit] = useState();

    const [ubicaciones, setUbicaciones] = useState([]);

    const fetchData = async () => {
        const data = await http.get('/ubicaciones');
        setUbicaciones(data.data);
    };

    useEffect(() => {
        dispatch(setIndex(1, 'Cat'));
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, []);

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    } = useTable(ubicaciones, headCells, filterFn);

    const [filter, setFilter] = useState();

    const handleSearch = (e) => {
        const { target } = e;
        setFilter(target.value);

        setFilterFn({
            fn: (items) => {
                if (target.value === '') {
                    return items;
                }
                const filteredItems = filterOnAnyField(items, target.value.toLowerCase());
                return filteredItems;
            },
        });
    };

    const addOrEdit = async (ubicacion, resetForm) => {
        await http.post('/ubicaciones', ubicacion);
        await fetchData();
        setOpenPopup(false);
        resetForm();
    };

    const openInPopup = (item) => {
        setRecordForEdit(item);
        setOpenPopup(true);
    };

    const [confirmDialog, setConfirmDialog] = useState({
        title: 'title',
        subtitle: 'subtitle',
        isOpen: false,
    });

    const deleteUbicacion = (item) => {
        setConfirmDialog({
            subtitle: '',
            title: 'Desea borrar la Ubicacion?',
            isOpen: true,
            onConfirm: async () => {
                await http.delete(`/ubicaciones/${item.id}`);
                await fetchData();
            },
        });
    };
    return (
        <>
            <PageHeader
                icon={<LocationCityOutlined fontSize='large' />}
                subtitle=''
                title='Ubicaciones'
            />
            <Paper className={classes.pageContent}>
                <Toolbar>
                    <Controls.Input
                        className={classes.searchInput}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position='end'>
                                    <Search />
                                </InputAdornment>
                            ),
                        }}
                        label='Buscar'
                        onChange={handleSearch}
                        value={filter}
                    />
                    <Controls.Button
                        className={classes.refreshButton}
                        onClick={async () => {
                            fetchData();
                        }}
                        startIcon={<RefreshIcon />}
                        text='Refrescar'
                        variant='outlined'
                    />
                    <Controls.Button
                        className={classes.newButton}
                        onClick={() => {
                            setRecordForEdit(null);
                            setOpenPopup(true);
                        }}
                        startIcon={<AddIcon />}
                        text='Agregar Nueva'
                        variant='outlined'
                    />
                </Toolbar>
                <TblContainer>
                    <TblHead />
                    <TableBody>
                        {recordsAfterPagingAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.nombre}</TableCell>
                                <TableCell>{item.telefono}</TableCell>
                                <TableCell>{item.contacto}</TableCell>
                                <TableCell>{item.direccion}</TableCell>
                                <TableCell>{item.url}</TableCell>

                                <TableCell>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => {
                                            openInPopup(item);
                                        }}
                                    >
                                        <EditOutlinedIcon fontSize='small' />
                                    </Controls.ActionButton>
                                    <Controls.ActionButton
                                        color='primary'
                                        onClick={() => {
                                            deleteUbicacion(item);
                                        }}
                                    >
                                        <DeleteForeverOutlined fontSize='small' />
                                    </Controls.ActionButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                title='Ubicacion'
            >
                <ClientesForm
                    addOrEdit={addOrEdit}
                    recordForEdit={recordForEdit}
                />
            </Popup>

            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
        </>
    );
}
